import "./styles.css";
import { useDispatch } from "react-redux";
import SingleSummary from "./SingleSummary";
import { Col, Row } from "antd";
import { useEffect, useState } from "react";
import { useRequiredAccess } from "../../../hooks/useRequiredAccess";
import { ORG_TYPES, ROLES } from "../../Common/Constants";
import { vehicleModelListUrl } from "../../Common/endpoints";
import { getApis } from "../../Common/apis";
import { setPageLoader } from "../../../reducers/loaderSlice";

function TestRidesComparison() {
  const dispatch = useDispatch()
  const [summaryList, setSummaryList] = useState([1]);
  const [modelList, setModelList] = useState([]);
  const [tripSummary, setTripSummary] = useState({});
  const authToken = localStorage.getItem("authToken");
  const checkAccess = useRequiredAccess(
    [
      ROLES.ADMIN,
      ROLES.EXECUTIVE,
      ROLES.TEST_RIDE_ENGINEER,
      ROLES.FLEET_MANAGER,
    ],
    [ORG_TYPES.ADMINISTRATOR, ORG_TYPES.MANUFACTURER]
  );

  useEffect(() => {
    checkAccess();
    if (modelList?.length === 0) {
      getVehicleModels();
      dispatch(setPageLoader("refresh"));
    }

    // eslint-disable-next-line
  }, []);

  const getVehicleModels = async () => {
    await getApis(vehicleModelListUrl, {}, authToken)
      .then((response) => {
        setModelList(response?.data);
        dispatch(setPageLoader(null));
      })
      .catch((error) => {
        console.log(error);
        dispatch(setPageLoader(null));
      });
  };

  const updateSummaryList = (data) => {
    setSummaryList(data);
  };

  const updateTripSummary = (data) => {
    setTripSummary(data);
  };

  return (
    <Row gutter={[16, 16]} className="test-ride-statistic">
      {summaryList.map((data, index) => (
        <Col
          sm={24}
          key={index}
          md={summaryList.length >= 2 ? 12 : 24}
          className="summary-col"
        >
          <SingleSummary
            data={data}
            modelList={modelList}
            summaryList={summaryList}
            tripSummary={tripSummary}
            updateSummaryList={updateSummaryList}
            updateTripSummary={updateTripSummary}
          />
        </Col>
      ))}
    </Row>
  );
}

export default TestRidesComparison;
